function switchLogo() {
  const logo = document.querySelector('.logoSwitch');
  // bodyにp-topクラスがあるか確認
  if (document.body.classList.contains('p-top')) {
    if (window.innerWidth <= 768) {
      // 768px以下の時は白いロゴを表示
      logo.src = 'assets/images/logo_wh.svg';
    } else {
      // 768pxを超えた時は通常のロゴを表示
      logo.src = 'assets/images/logo.svg';
    }
  }
}

// 初期読み込み時に呼び出し
switchLogo();

// ウィンドウのサイズが変わった時に呼び出し
window.addEventListener('resize', switchLogo);
